import React from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatDecimal, formatNumber, plural } from '../../../utilities/dashboard'
import ChartTooltip from './ChartTooltip'
import { ACTIVE_BAR, axisTick, CHART_DESC } from './DailyChart'
import useChartColors from './useChartColors'

const tooltipFor = (row, colors) => ({
  title: row.title,
  rows: [{ color: colors.primary, value: formatDecimal(row.average), label: 'atendimentos em média' }],
  notes: [`${formatNumber(row.total_atendimentos)} em ${plural(row.days_with_atendimentos, 'dia', 'dias')}`],
})

// Média por dia da semana. Eixo com uma casa decimal: as médias de um doutor são pequenas
const WeekdayChart = ({ rows, title }) => {
  const { chart: colors } = useChartColors()

  return (
    <ResponsiveContainer width='100%' height={220}>
      <BarChart data={rows} margin={{ top: 12, right: 8, bottom: 0, left: -6 }} accessibilityLayer title={title} desc={CHART_DESC}>
        <CartesianGrid vertical={false} stroke={colors.grid} />
        <XAxis dataKey='label' interval={0} tickLine={false} axisLine={{ stroke: colors.axis }} tick={axisTick(colors)} />
        <YAxis width={44} tickLine={false} axisLine={false} tick={axisTick(colors)} tickFormatter={(value) => formatDecimal(value)} />
        <Tooltip cursor={{ fill: colors.cursor }} content={<ChartTooltip render={tooltipFor} />} isAnimationActive={false} />
        <Bar dataKey='average' name='Média' fill={colors.primary} radius={[4, 4, 0, 0]} maxBarSize={24} activeBar={ACTIVE_BAR} isAnimationActive={false} />
      </BarChart>
    </ResponsiveContainer>
  )
}

export default WeekdayChart
